<template>
  <v-select
      :items="options"
      v-model="type"
      outlined
      hide-details="auto"
      :rules="rules"
      style="max-width: 15em"
  ></v-select>
</template>

<script>
export default {
  name: 'SiteNotificationTypeSelect',
  props: {
    value: {
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
  },
  computed: {

    type: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },

    options() {
      const types = ['INFO', 'WARNING'];
      return types.map(type => {
        return {
          text: this.$options.filters.siteNotificationType(type),
          value: type,
        };
      });
    },
  },
};
</script>
